import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import { getDashboardModalsDir } from '@wix/cli-app-definitions';
import type { DashboardModalConfig } from '@wix/cli-app-definitions';

// NOTE: path is relative to the build folder
const DASHBOARD_MODAL_TEMPLATE = path.resolve(
  __dirname,
  '../templates/dashboard-modal'
);

export async function generateDashboardModal(
  projectFolder: string,
  route: string,
  title: string
) {
  const cwd = path.join(getDashboardModalsDir(projectFolder), route);
  const modalConfig: DashboardModalConfig = {
    $schema: 'https://dev.wix.com/wix-cli/schemas/dashboard-modal.json',
    id: randomUUID(),
    title,
    width: 550,
    height: 600,
  };

  const modalConfigJSON = toJsonString(modalConfig, { spaces: 2 });

  return await componentGenerator({
    template: DASHBOARD_MODAL_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      modalId: modalConfig.id,
      route,
      title,
      modalConfigJSON,
    },
  });
}
